import request from '@/utils/request'

const systemURL = {
  List: '/message-push/system-notify-list',
  Detail: '/message-push/system-notify-detail',
  Create: '/message-push/system-notify-create',
  Delete: '/message-push/system-notify-delete',
  Cancel: '/message-push/cancel'
}

// 系统通知-列表
export function systemNotifyList (data) {
  return request({
    url: systemURL.List,
    method: 'post',
    data
  })
}

// 系统通知-详情
export function systemNotifyDetail (data) {
  return request({
    url: systemURL.Detail,
    method: 'post',
    data
  })
}

// 系统通知-创建
export function systemNotifyCreate (data) {
  return request({
    url: systemURL.Create,
    method: 'post',
    data
  })
}

// 系统通知-删除
export function systemNotifyDelete (data) {
  return request({
    url: systemURL.Delete,
    method: 'post',
    data
  })
}

// 撤销
export function messageCancel (data) {
  return request({
    url: systemURL.Cancel,
    method: 'post',
    data
  })
}

export default {
  systemNotifyList,
  systemNotifyDetail,
  systemNotifyCreate,
  systemNotifyDelete,
  messageCancel
}
